/**
 * Formats one monthly rand salary, e.g. "R18 000".
 * @param {number | string | null} amount Monthly salary in rands
 * @returns Formatted amount, or a dash when unset
 */
function formatMonthlySalary(amount) {
  if (amount === null || amount === undefined || amount === "") {
    return "-";
  }

  const numericAmount = Number(amount);
  if (Number.isNaN(numericAmount)) {
    return "-";
  }

  return `R${Math.round(numericAmount).toLocaleString("en-ZA").replace(/,/g, " ")}`;
}

/**
 * Formats the design's single Salary Range (Monthly) column, e.g. "R10 000 - R50 000".
 * @param {number | string | null} entryAmount Entry-level monthly salary
 * @param {number | string | null} expertAmount Expert-level monthly salary
 * @returns Range, single value, or a dash when neither is set
 */
export function formatSalaryRange(entryAmount, expertAmount) {
  const entry = formatMonthlySalary(entryAmount);
  const expert = formatMonthlySalary(expertAmount);

  if (entry === "-" && expert === "-") {
    return "-";
  }
  if (entry === "-") {
    return expert;
  }
  if (expert === "-") {
    return entry;
  }
  return `${entry} – ${expert}`;
}

/**
 * Options still worth offering for one filter, given what the other filters
 * already exclude. Its own selection is ignored so choices stay removable.
 * @param {Array<object>} rows Every row the table can show
 * @param {Array<object>} filters All filter definitions
 * @param {object} filterValues Current selections, keyed by filter key
 * @param {object} filter The filter being built
 * @returns Option list
 */
export function applicableFilterOptions(rows, filters, filterValues, filter) {
  const matching = rows.filter((row) =>
    filters.every((other) => {
      if (other.key === filter.key) {
        return true;
      }
      const selected = (filterValues[other.key] || {}).arr || [];
      return !selected.length || selected.includes(other.readValue(row));
    })
  );

  const values = matching
    .map(filter.readValue)
    .filter((value) => value !== null && value !== undefined && value !== "");

  return [...new Set(values)].map((value) => ({ value, label: String(value) }));
}
